import React from "react";
import { HRProvider } from "../HRContext";
import PositionList from "../positions/PositionList";

const PositionListWrapper: React.FC = () => {
  return (
    <HRProvider>
      <PositionList />
    </HRProvider>
  );
};

export default PositionListWrapper;
